(function () {
    // NOTE: This service is deprecated and no longer used.
    // The active configuration is in imageViewer.provider.js which uses config.json
    // Keeping this module definition only for backwards compatibility
    angular.module('evtviewer.imageViewerService', ['evtviewer.dataHandler']);
})();
